export const ValidationStrings = Object.freeze({

  // PHONE_NUMBER: /^[0-9+]+$/,
  NAME: /\D+/,
  PHONE_NUMBER: /^[0-9]{1,4}\-[0-9]{7,12}$/,
  EMAIL: /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/,
  PASSWORD: /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{8,}$/,
});
